import { Expo, Linear, TimelineMax } from "gsap";
import * as HLF from "html-living-framework";
import { Application } from "../Application";
import * as Constants from "../Data/Constants";
import * as SFX from "../Data/SoundEffect";
import CustomBounce from "../vendor/CustomBounce";
import CultureBackground from "./CultureBackground";

export default class EgyptBackground extends CultureBackground {

    private readonly _foregroundPots: PIXI.Sprite[];
    private readonly _backgroundObjects: PIXI.Sprite[];

    constructor() {
        super();
        this._foregroundPots = [
            HLF.PixiUtils.makeSprite("background-02-06", Constants.SPRITESHEET_GAME),
            HLF.PixiUtils.makeSprite("background-02-07", Constants.SPRITESHEET_GAME),
            HLF.PixiUtils.makeSprite("background-02-08", Constants.SPRITESHEET_GAME),
        ];
        this._backgroundObjects = [
            HLF.PixiUtils.makeSprite("background-02-00", Constants.SPRITESHEET_GAME),
            HLF.PixiUtils.makeSprite("background-02-01", Constants.SPRITESHEET_GAME),
            HLF.PixiUtils.makeSprite("background-02-02", Constants.SPRITESHEET_GAME),
            HLF.PixiUtils.makeSprite("background-02-03", Constants.SPRITESHEET_GAME),
            HLF.PixiUtils.makeSprite("background-02-04", Constants.SPRITESHEET_GAME),
            HLF.PixiUtils.makeSprite("background-02-05", Constants.SPRITESHEET_GAME),
            HLF.PixiUtils.makeSprite("background-02-09", Constants.SPRITESHEET_GAME),
        ];
        this.addChild(
            ...this._backgroundObjects,
            ...this._foregroundPots,
        );
        CustomBounce.create("customBounce-egypt", { strength: 0.3, squash: 0 });
    }

    /** @override */
    public AnimateIn(pCallback: () => void, pDelay: number = 0): void {
        if (this._introTimeline !== undefined) {
            this._introTimeline.kill();
        }
        this._introTimeline = new TimelineMax();
        // this._introTimeline.clear();

        this._introTimeline
            .fromTo(this._foregroundPots, 2,
                {pixi: {positionY: this._size!.y / 2}},
                {pixi: {positionY: 0}, ease: Linear.easeIn},
                pDelay + 0.75,
            )
            .staggerFromTo(this._backgroundObjects, 1,
                {pixi: {positionY: -this._size!.y}},
                {pixi: { positionY: 0 }, ease: "customBounce-egypt"},
                0.2,
                pDelay,
                pCallback,
            )
            .call(() => this._introTimeline = undefined)
        ;
        for (let i = 0; i < this._backgroundObjects.length; i++) {
            const t = pDelay + 1 + (0.2 * i);
            this._introTimeline.call(() => {
                Application.instance.audio.play(HLF.ArrayUtils.random(SFX.IMPACTS), 0.5, false, HLF.AudioCategory.SFX);
            }, undefined, undefined, t);
        }
    }
    /** @override */
    public AnimateOut() {
        if (this._outroTimeline !== undefined) {
            this._outroTimeline.kill();
        }
        this._outroTimeline = new TimelineMax();
        // this._outroTimeline.clear();

        this._outroTimeline
            .to(this._backgroundObjects, 0.5, {pixi: {positionY: this._size!.y, ease: Expo.easeOut}}, 0)
            .to(this._foregroundPots, 1, {pixi: {positionY: this._size!.y / 2}}, 1)
            .call(() => this._outroTimeline = undefined)

            // .play(0, false)
        ;

    }
}
